/**
 * Shared Framer Motion variants — extracted to module scope so prop references
 * are stable across renders (avoids unnecessary re-renders from inline objects).
 */
export const SPRING_HOVER = { type: "spring", stiffness: 380, damping: 26 };
export const SPRING_TAP = { type: "spring", stiffness: 500, damping: 30 };
export const SPRING_LAYOUT = { type: "spring", stiffness: 500, damping: 35 };
export const SPRING_CARD_HOVER = { type: "spring", stiffness: 350, damping: 28 };
export const SPRING_DRAWER = { type: "spring", stiffness: 320, damping: 32 };
export const SPRING_SCORE = { type: "spring", stiffness: 200, damping: 18, delay: 0.3 };

export const EASING = [0.22, 1, 0.36, 1];

export const FADE_UP = {
  hidden: { opacity: 0, y: 14 },
  show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: EASING } },
};

export const FADE_UP_VIEWPORT = {
  initial: { opacity: 0, y: 12 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-40px" },
};

export const HERO_TITLE_PARENT = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { staggerChildren: 0.08 } },
};

export const HERO_TITLE_LINE = {
  hidden: { opacity: 0, y: 22 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: EASING } },
};

export const FADE_IN = { initial: { opacity: 0 }, animate: { opacity: 1 } };

export const TAP_98 = { whileTap: { scale: 0.98 } };
export const TAP_92 = { whileTap: { scale: 0.92 } };

export const CARD_HOVER_LIFT = { whileHover: { y: -4 }, transition: SPRING_CARD_HOVER };

export const STATUS_ENTRANCE = {
  initial: { opacity: 0, y: 10 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.4 },
};
